<!--
    客户端日志
    作用：展示客户端日志列表数据
    组件：AppList、AppSearch
    版本号: 3.0
-->
<template>
  <div class="clientLog">
    <AppList
      ref="list"
      :list.sync="list"
      title=""
      api="/api/service/operate/client_log_list">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        time-between="logs@"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
            <template v-for="column in columns">
              <el-table-column
                v-if="column.prop === 'file'"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
              >
                <template slot-scope="scope">
                  <el-link v-if="scope.row.file" :href="scope.row.file.replace('http://', 'https://')" download>下载</el-link>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column
                v-else-if="column.prop === 'remarks'"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
              >
                <template slot-scope="scope">
                  <p
                    v-if="scope.row.remarks"
                    class="remarks-p"
                    :title="scope.row.remarks"
                    style="-webkit-box-orient: vertical;"
                  >{{scope.row.remarks}}</p>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column
                v-else-if="column.prop === 'image'"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
              >
                <template slot-scope="scope">
                  <template v-if="scope.row.image && scope.row.image.length">
                    <el-row type="flex">
                      <img v-for="src in scope.row.image.split(',')" class="small-img" :src="src" @click="dialogImg.src = src; dialogImg.show = true;">
                    </el-row>
                  </template>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column
                v-else
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
            </template>
        </el-table>
      </template>
    </AppList>

    <el-dialog
      v-if="dialogImg.show"
      title="异常图片"
      :visible.sync="dialogImg.show"
      width="70vh">
      <img class="big-img" :src="dialogImg.src">
    </el-dialog>
  </div>
</template>

<script>
  import index from './';
  export default index;
</script>

<style scoped lang="scss">
  @import "index.scss"
</style>



// WEBPACK FOOTER //
// src/views/ClientLog/index.vue